import type { SocialCommentAuthorType } from "@multi-chat/shared";

/**
 * Prefer Meta-verified display name; fall back to @username.
 * Never invent a real name from a username handle.
 */
export function resolveCommentAuthorLabel(input: {
  authorDisplayName: string | null | undefined;
  authorUsername: string | null | undefined;
  unknownLabel: string;
}): { primary: string; secondaryUsername: string | null; isHandleOnly: boolean } {
  const display = input.authorDisplayName?.trim() || null;
  const username = input.authorUsername?.trim() || null;
  if (display) {
    return {
      primary: display,
      secondaryUsername: username && username !== display ? username : null,
      isHandleOnly: false,
    };
  }
  if (username) {
    return {
      primary: `@${username}`,
      secondaryUsername: null,
      isHandleOnly: true,
    };
  }
  return { primary: input.unknownLabel, secondaryUsername: null, isHandleOnly: false };
}

export function resolveConnectedAccountLabel(input: {
  accountDisplayName: string | null | undefined;
  accountUsername: string | null | undefined;
  fallbackLabel: string;
}): { primary: string; secondaryUsername: string | null } {
  const display = input.accountDisplayName?.trim() || null;
  const username = input.accountUsername?.trim() || null;
  if (display) {
    return {
      primary: display,
      secondaryUsername: username && `@${username}` !== display && username !== display ? username : null,
    };
  }
  if (username) {
    return { primary: `@${username}`, secondaryUsername: null };
  }
  return { primary: input.fallbackLabel, secondaryUsername: null };
}

export function isBusinessSelfAuthor(authorType: SocialCommentAuthorType): boolean {
  return authorType === "BUSINESS_SELF";
}
